import { IResourceComponentsProps, useForm } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8Edit from "components/cw8/Cw8Edit";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import { ChildForm } from "interfaces/schemaDB";

export const SectionPubsEdit: React.FC<IResourceComponentsProps> = () => {
    // return <AntdInferencer />;

    const resourceLabel :string = 'Sección';
    const resourceName :string = 'sectionPub';
    const { id } = useForm();
    const childrenForms : ChildForm[] =[
        
        {
            resourceName :"subsectionPub",
            title : "Subsecciones1",
            field : "sup_id_section"
        },
        {
            resourceName :"autorSectionPublication",
            title : "Autores",
            field : "aup_idSectionPub"
        },
    ]

    return(
        <Cw8EditWrapper
            resourceLabel = {resourceLabel}
            resourceName = {resourceName}
            id = {id}
            childrenForms = {childrenForms}
        ></Cw8EditWrapper>
    )
        
};
